import styled from '@emotion/styled';
import { useSettingModal} from '../hooks/Context';
import { SettingContextI } from '../types';
import {FaTimes as CancelIcon} from 'react-icons/fa';
import {useEffect} from 'react';




export const ModalContainer = styled.div`
    position: fixed;
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    background-color: #4E534F80;
    z-index: 1000;
    top:0;
    left: 0;
    overflow-x:hidden;
    overflow-y:scroll;


`;

export const StyleCancel = styled.span`
    position:absolute;
    top:0px;
    right:-50px;
    width:40px;
    height:40px;
    color:#fff;
    background-color: rgba(255,255,255,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 20px;
    cursor: pointer;
`;

export const ModalContent = styled.div`
    width:fit-content;
    position: relative;
    top:50px;
    background-color: #fff;
    height:fit-content !important;
`;

const BackDrop = styled.div`
        height: 100%;
        width: 100%;
        position: fixed;
        `;


export default  function CustomModal(props:any){
    const {modalContent:modal,showModal:show,setShowModal,setModalContent,setShowCancel,showCancel}:SettingContextI = useSettingModal();
    useEffect(()=>{
        return () =>{setModalContent(<div></div>);setShowCancel(true)}
    },[])
    return(
        <>
        {show ?
            <ModalContainer >
                <ModalContent>
                    {showCancel ?
                        <StyleCancel onClick={()=>setShowModal(false)}>
                            <CancelIcon />
                        </StyleCancel>
                    :''}
                    {modal}
                </ModalContent>
                <BackDrop onClick={()=>setShowModal(false)}/>
            </ModalContainer>
        :''}
        
        </>

     
    )
}